import {find} from '../helpers';

// const element = find('[data-video-stream]');
const video = find('[data-video]');
const videoBg = find('[data-video-bg]');

// if (element) {
//     import('./index').catch((err) => {
//         console.error('Failed to load video player:', err);
//     });
// }

if (video) {
    import('./video').catch((err) => {
        console.error('Failed to load video player:', err);
    });
}

if (videoBg) {
    import('./hero').catch((err) => {
        console.error('Failed to load video player:', err);
    });
}
